module.exports = __webpack_public_path__ + "static/media/Flying-Soffit3.e1a2f942.jpeg";